import axios from "@/utils/axios";

// 获取找回密码时的验证码
export const getCheckCode = (data) => {
  return axios.post({
    url: "/sendAuthCode",
    data,
  });
};

// new 发送验证邮件 目前在找回密码中使用
export const getCheckCodeEmail = (data) => {
  return axios.post({
    url: "/v1/forget-pass/send-verify-email",
    data,
  });
};

// 确认重置密码第一步  确认用户名 邮箱 邮箱验证码
export const nextStep = (data) => {
  return axios.post({
    url: "/v1/forget-pass/verify",
    data,
  });
};


// 设置新密码
export const setNewPassword = (data) => {
  return axios.post({
    url: "/setNewPassword",
    data,
  });
};

export const setPasswordNew = (data) => {
  return axios.post({
    url: "/v1/forget-pass/reset-password",
    data,
  });
};

// 获取验证码 接口  手机
export const sendSmsAuthCode = (data) => {
  return axios.post({
    url: "/sendSmsAuthCode",
    data,
  });
};

// 获取验证码 接口  手机
export const sendSmsAuthCodeNew = (data) => {
  return axios.post({
    url: "/v1/sms-login/send-verify-code",
    data,
  });
};


// 手机验证码登录

export const addMobileCheck = (data) => {
  return axios.post({
    url: "/addMobileCheck",
    data,
  });
};

// 绑定手机号
export const saveMobile = (data) => {
  return axios.post({
    url: "/saveMobile",
    data,
  });
};

export const removeMobile = (data) => {
  return axios.post({
    url: "/removeMobile",
    data,
  });
};

// 第三方数据绑定
export const addThirdpartyAccount = (data) => {
  return axios.post({
    url: "/v1/sso-user/login/bindThirdParty",
    data,
  });
};